import React, { useState } from 'react';

import styled from '@emotion/styled';

import EyeIcon from '../Icons/EyeIcon';
import { Modal } from '../Modal/Modal';
import PreviewImageModal from '../Modal/ModalActions/PreviewImageModal/PreviewImageModal';

interface EyeIconWrapperProps {
  setShowModal: (...args: any) => void;
}

const EyeIconWrapper: React.FC<EyeIconWrapperProps> = ({ setShowModal }) => {
  return (
    <EyeIconArea onClick={() => setShowModal(true)}>
      <EyeIcon />
    </EyeIconArea>
  );
};

interface PreviewAbleImageProps {
  imgUrl: string;
}
const PreviewAbleImage: React.FC<PreviewAbleImageProps> = ({ imgUrl }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <Container>
        <EyeIconWrapper setShowModal={setShowModal} />
        <ImgDiv onClick={() => setShowModal(true)}>
          <Img src={imgUrl} alt='signature image' />
        </ImgDiv>
      </Container>

      <Modal showModal={showModal} setShowModal={setShowModal}>
        <PreviewImageModal imgUrl={imgUrl} />
      </Modal>
    </>
  );
};

export default PreviewAbleImage;

const Container = styled.div`
  display: grid;
  place-content: center;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 6px;
  padding: 9px;
  height: 117px;
  width: 117px;

  @media (max-width: 884px) {
    width: 100%;
    max-width: 117px;
    height: auto;
    aspect-ratio: 1;
  }

  & > * {
    grid-column: 1;
    grid-row: 1;
    border-radius: 4px;
  }
`;

const ImgDiv = styled.div`
  display: grid;
  place-content: center;
  height: 99px;
  width: 99px;
  overflow: hidden;

  @media (max-width: 884px) {
    width: 100%;
    height: 100%;
  }
`;

const Img = styled.img`
  object-position: center;
  object-fit: contain;
  height: 99px;
  width: 99px;

  @media (max-width: 884px) {
    width: 100%;
    height: 100%;
  }
`;
const EyeIconArea = styled.div`
  display: grid;
  place-content: center;
  background-color: rgba(0, 0, 0, 0.4);
  transition: 3s transform ease-in-out;
  z-index: 1;
  cursor: pointer;

  &:hover + * > img {
    transform: scale(110%);
  }

  & + * > img {
    transition: 0.3s transform ease-in-out;
  }
`;
